import React, { useState } from 'react'
import {  useLocation } from 'react-router-dom'
import Tabs from '../../../components/Tabs'
import styles from './ModelTabs.module.scss'
import { useGeoState } from '../../../components/GeoProvider'
import Spinner from '../../../components/Loader/Spinner'
import PollenLineChartCompare from './PollenLineChartCompare'
import PollutantLineChartCompare from './PollutantLineChartCompare'
import getVectorImage from '../../../utils/getVectorImage'
import moment from 'moment'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
const ModelTabs = ({
  pollutantChartData,pollenChartData,geo_parent,geo_type, geo_id, data_type,
  dataCategoryPollen,dataCategoryPollutant 
  
}) => {
  let fromdate=''
  let todate=''
  let load_date=''
  if(pollutantChartData.length>0)
    {
      let json_value=(pollutantChartData[0].json_value)
      if(json_value!==null)
        {
          fromdate=moment(json_value[0].x).format('MMM DD, YYYY')
          todate=moment(json_value[json_value.length-1].x).format('MMM DD, YYYY')
          load_date= dayjs().day(+1).format('MMM DD, YYYY')
        }

    }
  const tabIndices = React.useMemo(
    () => [ '#pollutants', '#pollen'],
    []
  )
  const [selectedTab, setSelectedTab] = React.useState(0)

  const history = useHistory()
  const location = useLocation()
  // const [filterState,setFilterState]=React.useState(1)
  const {
    getAllergyFilterState,
    setAllergyFilterState
  } = useGeoState()
  const onLoadTabs = React.useCallback(() => {
    for (const key in tabIndices) {
      if (location.hash === tabIndices[key]) setSelectedTab(+key)
    }
  }, [location.hash, tabIndices])

  const tabsChangeHandler = (index) => {
    setSelectedTab(index)
    history.push({ hash: tabIndices[index] })
  }

  React.useEffect(() => {
    onLoadTabs()
  }, [onLoadTabs])
 let chartWidth='100%'
  // var dataobject = data[displayDate]
  // var mathIdentifier = Object.keys(dataobject)[0] === identifier
  const handlefilterState = (index) => {
    if(index===1)
      {chartWidth='100px'}
    else if(index===2)
      {
        chartWidth='1500px'
      }
      else{
        chartWidth='2500px'
      }
    //  setFilterState(index)
     setAllergyFilterState(index)
  }


  return (
    <>
      <Tabs selectedIndex={selectedTab} onChange={tabsChangeHandler}>
        <Tabs.Panel label="Pollutants Trends">
          {tabIndices[selectedTab] === '#pollutants' ? (
            <>
            <div style={{display:'flex'}}>
            <div className={styles.filterDiv}>
              <div style={{fontSize:'16px',padding:'5px'}}>Zoom</div>
              <div onClick={(event) => handlefilterState(1)} className={getAllergyFilterState===1?styles.activeWeekDiv:styles.weekDiv}>10w</div>
              <div onClick={(event) => handlefilterState(2)} className={getAllergyFilterState===2?styles.activeWeekDiv:styles.weekDiv}>24w</div>
              <div onClick={(event) => handlefilterState(3)} className={getAllergyFilterState===3?styles.activeWeekDiv:styles.weekDiv}>52w</div>
            </div>
            <div className={fromdate!==''?styles.dateDiv:styles.hideDateDiv}>
            <span>{fromdate}</span>{getVectorImage('arrowforward','16px', '12px')}<span>{todate}</span> Updated for <span>{load_date}</span>
            </div>
            </div>
            <PollutantLineChartCompare
            geo_parent={geo_parent}
            geo_type={geo_type} 
            geo_id={geo_id} 
            data_type= {data_type}
            filter={getAllergyFilterState}
            chartData={pollutantChartData}
            dataCategory={dataCategoryPollutant}
            />
            <hr style={{width:'96%',marginLeft:'2%',height:'1px',backgroundColor:'#CBCCCD'}}/>
            
            </>
           
          ) : (
            <Spinner />
          )}
        </Tabs.Panel>
        <Tabs.Panel label="Pollen Trends">
          {tabIndices[selectedTab] === '#pollen' ? (
            <>
             <div className={styles.filterDiv}>
              <div style={{fontSize:'16px'}}>Zoom</div>
              <div onClick={(event) => handlefilterState(1)} className={getAllergyFilterState===1?styles.activeWeekDiv:styles.weekDiv}>10w</div>
              <div onClick={(event) => handlefilterState(2)} className={getAllergyFilterState===2?styles.activeWeekDiv:styles.weekDiv}>24w</div>
              <div onClick={(event) => handlefilterState(3)} className={getAllergyFilterState===3?styles.activeWeekDiv:styles.weekDiv}>52w</div>
            </div>
             <PollenLineChartCompare
            geo_parent={geo_parent}
            geo_type={geo_type} 
            geo_id={geo_id} 
            data_type= {data_type}
            filter={getAllergyFilterState}
            chartData={pollenChartData}
            dataCategory={dataCategoryPollen}
            />
            <hr style={{width:'96%',marginLeft:'2%',height:'1px',backgroundColor:'#CBCCCD'}}/>
             
            </>
          ) : (
            <Spinner />
          )}
        </Tabs.Panel>
       
      </Tabs>
     
    </>
  )
}

export default ModelTabs
